import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import Recensioni from './components/recensioni'
//? import delle immagini
import sfondo from '../asset/sfondo.png'
import arrow from '../asset/components/Double Down.png'

//? import componenti per le animazioni
import BlurText from './componentsAnimated/BlurText'

gsap.registerPlugin(ScrollTrigger)

export default function LandingPage () {
  const container = useRef()
  const subtext = useRef()
  const arrowRef = useRef()

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(container.current, {
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: 'power3.out'
      })

      gsap.from(subtext.current, {
        opacity: 0,
        y: 30,
        delay: 0.5,
        duration: 1,
        ease: 'power2.out'
      })

      gsap.to(arrowRef.current, {
        y: 10,
        repeat: -1,
        yoyo: true,
        duration: 0.8,
        ease: 'power1.inOut'
      })
    })

    return () => ctx.revert()
  }, [])

  return (
    <div className="flex justify-center lg:pl-8 lg:pr-8 pr-4 pl-4">
      <div
        className="relative w-full p-4 pt-8 pb-8 h-[700px] flex justify-center rounded-3xl overflow-hidden shadow-2xl"
        style={{
          backgroundImage: `url(${sfondo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        {/* Overlay scuro */}
        <div className="absolute inset-0 bg-black/25 z-0"></div>

        {/* Contenuto sopra lo sfondo */}
        <div
          ref={container}
          className="relative z-10 text-white text-center pt-35"
        >
          <BlurText
            text="Lario Clima Service"
            delay={300}
            animateBy="words"
            direction="top"
            className="lg:text-9xl text-[#173341] text-5xl font-bold drop-shadow-xl justify-center"
          />
          <p
            ref={subtext}
            className="lg:mt-2 mt-4 lg:text-3xl text-xl font-thin"
          >
            Quando serve un vero professionista, il tuo tecnico è Nordin
          </p>
          <Recensioni />

          <p className="lg:mt-10 mt-10 lg:text-3xl text-xl font-thin">
            Scorri per scoprire
          </p>
          <div className="flex justify-center">
            <img ref={arrowRef} src={arrow} alt="freccia giù" />
          </div>
        </div>
      </div>
    </div>
  )
}
